import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/GestionSucesos",
      name: "gestionsucesos",
      component: () => import("./components/GestionSucesos.vue")
    },
    {
      path: "/Summary",
      name: "resumen",
      component: () => import("./views/Summary.vue"),
    },
    {
      path:"/SumaryTravel/:id_tracking/:transport_company_name",
        name:"resumenViaje",
        component: () => import("./views/SummaryTravel.vue")
    }
  ]
});
